export const affiliate = {
  seo: {
    title: "Bespire Affiliate Program - Earn €300 with every referral",
    description: "Join the Bespire affiliate program! Earn €300 after each successful referral. Free registration, instant link generation.",
    keywords: "affiliate program, partner program, commission, earning opportunity, Bespire"
  },
  navigation: {
    howItWorks: "How it works",
    benefits: "Benefits", 
    calculator: "Calculator",
    getStarted: "Get started",
    backToHome: "Back to homepage"
  },
  hero: {
    badge: "Bespire affiliate program",
    title: {
      earn: "Earn",
      amount: "€300",
      withEvery: "with every referral"
    },
    description: "Recommend Bespire to others and earn serious money! Joining is completely free, no hidden fees, just pure profit.",
    buttons: {
      getStarted: "Let's start now!",
      howItWorks: "How does it work?"
    }
  },
  stats: {
    commission: {
      value: "€300",
      label: "Commission amount"
    },
    threshold: {
      value: "€3000",
      label: "After paying"
    },
    registration: {
      value: "€0",
      label: "Registration"
    },
    referrals: {
      value: "∞",
      label: "Number of referrals"
    }
  },
  steps: {
    title: "It's that simple",
    description: "You can earn money in 4 steps - no complicated process, just results",
    items: [
      {
        title: "1. Register",
        description: "Just one email address needed - completely free!"
      },
      {
        title: "2. Get your link",
        description: "You'll immediately receive your unique affiliate link"
      },
      {
        title: "3. Share it",
        description: "Send it to your friends, followers, everyone!"
      },
      {
        title: "4. Earn money",
        description: "€300 commission after every successful referral"
      }
    ]
  },
  benefits: {
    title: "Why should you join?",
    description: "The best conditions and highest commissions await you",
    items: [
      {
        title: "High commission",
        description: "€300 after every successful referral - this is one of the highest in the market!"
      },
      {
        title: "Fast payout",
        description: "As soon as the referred creator reaches €3000 in sales, we transfer immediately"
      },
      {
        title: "Help others",
        description: "You provide creators with an opportunity for self-realization"
      },
      {
        title: "No limit",
        description: "You can refer as many people as you want"
      }
    ]
  },
  calculator: {
    title: "How much can you earn?",
    description: "Calculate how much revenue you can expect from your referrals",
    scenarios: [
      {
        referrals: "1",
        title: "referral",
        amount: "€300",
        description: "After one successful referral"
      },
      {
        referrals: "5", 
        title: "referrals",
        amount: "€1500",
        description: "Already a nice side income"
      },
      {
        referrals: "10",
        title: "referrals", 
        amount: "€3000",
        description: "Could even be suitable as a main job"
      }
    ],
    note: {
      title: "Important:",
      description: "There's no limit! You can refer as many people as you want. You get €300 commission after every successful referral."
    }
  },
  registration: {
    title: "Let's start now!",
    description: "Register now and you'll immediately receive your unique affiliate link",
    form: {
      email: "Your email",
      confirmEmail: "Confirm email",
      password: "Password",
      emailPlaceholder: "example@email.com",
      passwordPlaceholder: "••••••••",
      submitButton: "I register and get my link!",
      submitting: "Registration in progress..."
    },
    benefits: [
      "Completely free registration",
      "Instant link generation", 
      "€300 commission after every successful referral",
      "No limit on number of referrals"
    ]
  },
  faq: {
    title: "Frequently Asked Questions",
    description: "Here you'll find the most frequently asked questions about our affiliate program",
    questions: [
      {
        question: "What is the commission rate?",
        answer: "I pay €300 commission after every successful referral. This is earned when the creator you referred reaches €3000 in sales on the platform."
      },
      {
        question: "When do I receive my commission?",
        answer: "We transfer the commission immediately once the referred creator reaches €3000 in sales. No waiting time, no conditions."
      },
      {
        question: "Is there a limit on the number of referrals?",
        answer: "No! You can refer as many people as you want. You get the €300 commission after every successful referral."
      },
      {
        question: "What do I need to do after registration?",
        answer: "After registration you immediately receive your unique affiliate link. You just need to share it with others - via email, social media, anywhere."
      },
      {
        question: "How can I track my referrals?",
        answer: "After registration you get access to a simple dashboard where you can track your referrals and commissions in real time."
      },
      {
        question: "Do I need to pay anything?",
        answer: "Not at all! Registration is completely free, no hidden fees, no monthly costs. You can only earn, you don't have to pay anything."
      },
      {
        question: "What support do I get?",
        answer: "We provide full support: marketing materials, banners, texts and personal help to generate as many successful referrals as possible."
      },
      {
        question: "When does a referral count as successful?",
        answer: "When someone registers from your affiliate link and reaches €3000 in sales on the platform. After that you automatically receive the €300 commission."
      }
    ],
    contactPrompt: "Have more questions? Write to us!",
    contactButton: "Contact"
  },
  footer: {
    company: {
      description: "Build your creator empire with AI-powered tools"
    },
    features: {
      title: "Features",
      howToStart: "How to start",
      whatToSell: "What you can sell",
      partnerProgram: "Partner program",
      pricing: "Pricing"
    },
    support: {
      title: "Support",
      privacy: "Privacy",
      terms: "Terms",
      aboutUs: "About us"
    },
    newsletter: {
      title: "Our newsletter",
      description: "Subscribe to our newsletter for the latest news and tips!",
      emailPlaceholder: "Your email address",
      subscribeButton: "Subscribe"
    },
    bottom: {
      copyright: "© 2024 Bespire. All rights reserved.",
      madeWithLove: "Developed with love ❤️",
      systemStatus: "System operational"
    }
  }
};